import { useSelector } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { tLocale } from "@/types";

export const useLocale = (): tLocale => {
  return useSelector(UserSelectors.getLocale);
};
